import React, { useContext, useEffect, useState } from 'react';

import { Box, Grid, useTheme } from '@mui/material';
import { Screen } from '../../components';
import { makeStyles } from '@mui/styles';
import { PatientTabChart, PatientTableResults, PatientTabs } from './components/';
import { PatientTabsContext, PatientTabsContextProvider } from '../../lib/contexts/PatientTabsContext';
import { PartnerContext } from '../../lib/contexts';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  screen: theme.globalClasses.screen,
  inlineTitle: {
    fontWeight: 800,
    fontSize: 30,
    color: theme.palette.admin.greysBlack,
    cursor: 'default',
    whiteSpace: 'nowrap',
  },
}));

const PatientsContent = () => {
  const theme = useTheme();
  const {
    state: { openTabs, activeTab, currentTab },
  } = useContext(PatientTabsContext);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
      }}
    >
      <Grid
        container
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          width: '100%',
          gap: 3,
          mb: 5,
        }}
      >
        <Grid item>
          <PageTitleCloseTabs />
        </Grid>
        <Grid
          item
          xs
        >
          <PatientTabs />
        </Grid>
      </Grid>
      <PageSwitcher />
    </Box>
  );
};

const PatientsScreen = () => {
  const classes = useStyles();
  const [showSidebarNav, setShowSidebarNav] = useState(true);

  return (
    <Screen
      title={'Patients - Diet ID'}
      showSidebarNav={showSidebarNav}
      admin={true}
    >
      <Grid
        container
        alignItems="center"
        spacing={0}
        className={classes.screen}
      >
        <PatientTabsContextProvider>
          <PatientsContent />
        </PatientTabsContextProvider>
      </Grid>
    </Screen>
  );
};

const PageTitleCloseTabs = () => {
  const classes = useStyles();
  const {
    actions: { goHomeTab },
  } = useContext(PatientTabsContext);

  return (
    <Grid item>
      <Box
        className={classes.inlineTitle}
        onClick={goHomeTab}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <Box>Patient Charts</Box>
        </Box>
      </Box>
    </Grid>
  );
};

const PageSwitcher = () => {
  let { uuid, listId } = useParams();
  const navigate = useNavigate();

  const {
    state: { openTabs, activeTab, currentTab },
    actions: { setActiveTab },
  } = useContext(PatientTabsContext);
  const {
    state: { code },
  } = useContext(PartnerContext);

  // DEBUG: this has to be fixed so the same uuid opens in the same tab
  // currentTab.uuid === activeTab.uuid - replace?
  useEffect(() => {
    if ((currentTab && currentTab.uuid !== uuid) || (activeTab && activeTab != uuid)) {
      const tabExists = openTabs.some((tab) => {
        return tab.uuid === currentTab?.uuid;
      });
      if (tabExists) {
        // Just make the existing tab active
        setActiveTab(currentTab.uuid);
      }
      navigate('../patients/' + currentTab.uuid, { replace: true });
      //alert(JSON.stringify(currentTab))
      //window.history.replaceState(null,
      //  currentTab ? currentTab.firstName + ' ' + currentTab.lastName + ' | ' : '' + window.document.title,
      //  getClientHost(code) + '/patients/' + currentTab.uuid);
    } else {
      if (openTabs.length > 0 && activeTab == null && listId == null) {
        navigate('../patients/', { replace: true });
        //window.history.replaceState(null, window.document.title,getClientHost(code) + '/patients/');
      }
    }
  }, [currentTab, activeTab, openTabs, code, uuid, navigate]);

  return activeTab != null ? <PatientTabChart /> : <PatientTableResults />;
};

export default PatientsScreen;
